import Vue from 'vue';
import StackedToast from 'commons/js/components/atoms/StackedToast';

// cria a primeira instancia do toast
function createToastComponent(toastData, vm) {
  const StackedToastClass = Vue.extend(StackedToast);
  const stackedToastInstance = new StackedToastClass({
    propsData: {
      timeout: 6000
    }
  });
  stackedToastInstance.$mount();
  vm.$el.appendChild(stackedToastInstance.$el);
  stackedToastInstance.createToast(toastData.content, toastData.type);
};

// lida com o evento disparado para mostrar o toast
function handleToast(toastData, vm) {
  const toastWrapper = document.querySelector('.me-toast__container');
  if (toastWrapper) {
    toastWrapper.parentNode.removeChild(toastWrapper);
  }
  createToastComponent(toastData, vm);
};

export {
  createToastComponent,
  handleToast,
}